export interface MultiSelectOption {
  value: string;
  label: string;
  depth?: number;
  disabled?: boolean;
  description?: string;
  searchText?: string;
}

export function getMultiSelectSummary(
  options: MultiSelectOption[],
  selectedValues: string[],
  placeholder: string,
  maxVisibleLabels = 2,
): string {
  if (selectedValues.length === 0) return placeholder;

  const labelsByValue = new Map(options.map((option) => [option.value, option.label]));
  const selectedLabels = selectedValues.map((value) => labelsByValue.get(value) ?? value);

  if (selectedLabels.length <= maxVisibleLabels) {
    return selectedLabels.join(", ");
  }

  return `${selectedLabels.length} selected`;
}

export function toggleMultiSelectValue(selectedValues: string[], value: string): string[] {
  if (selectedValues.includes(value)) {
    return selectedValues.filter((selectedValue) => selectedValue !== value);
  }
  return [...selectedValues, value];
}

export function filterMultiSelectOptions(
  options: MultiSelectOption[],
  query: string,
): MultiSelectOption[] {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  if (!normalizedQuery) return options;

  return options.filter((option) => {
    const searchable = `${option.label} ${option.searchText ?? ""}`.toLocaleLowerCase();
    return searchable.includes(normalizedQuery);
  });
}
